var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_3948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8886 0.186546C12.7556 0.0210461 12.5321 -0.0424539 12.3331 0.0290461C12.1741 0.0850461 12.0566 0.216546 12.0156 0.374546C11.9121 0.570546 11.4031 1.26355 10.8651 1.99605C8.38413 5.37455 3.76562 11.6635 3.76562 15.265C3.76562 20.0815 7.68363 24 12.4991 24C17.3156 24 21.2336 20.0815 21.2336 15.265C21.2336 10.595 13.2296 0.609046 12.8886 0.186546Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_3948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/drop-icon.766b41b117780dc1ce14b96596e6010e.svg";
export { ForwardRef as ReactComponent };